<template>
	<section>
		<div class="level">
			<div class="level-left">
				<div class="level-item">
					<b-field label="Search term" custom-class="is-small">
						<input
							@focus="$event.target.select()"
							class="input"
							type="text"
							v-model="$store.state.propertiesFilter.searchTerm"
							v-on:keyup="filterProperties()"
							placeholder="Search for anything..."
						/>
					</b-field>
				</div>
				<div class="level-item">
					<div class="level-item">
						<b-field
							label="Filter on date last modified?"
							custom-class="is-small"
						>
							<b-switch
								@input="filterProperties()"
								v-model="$store.state.propertiesFilter.useDates"
							></b-switch>
						</b-field>
					</div>

					<b-field
						label="Start date"
						custom-class="is-small"
						v-if="$store.state.propertiesFilter.useDates"
					>
						<b-datepicker
							placeholder="Start date..."
							icon="calendar-today"
							@input="filterProperties()"
							v-model="$store.state.propertiesFilter.startDate"
							@keyup.enter="filterProperties()"
						></b-datepicker>
					</b-field>
				</div>

				<div class="level-item" v-if="$store.state.propertiesFilter.useDates">
					<b-field label="End date" custom-class="is-small">
						<b-datepicker
							placeholder="End date..."
							icon="calendar-today"
							@input="filterProperties()"
							v-model="$store.state.propertiesFilter.endDate"
							@keyup.enter="filterProperties()"
						></b-datepicker>
					</b-field>
				</div>
			</div>
		</div>

		<div class="level">
			<div class="level-left">
				<b-field label="Stages" custom-class="is-small">
					<b-field grouped group-multiline>
						<b-field>
							<span>
								<b-tooltip label="All">
									<button class="button is-rounded" v-on:click="setAll()">
										<i class="fas fa-eye"></i>
									</button>
								</b-tooltip>
							</span>

							<span>
								<b-tooltip label="None">
									<button class="button is-rounded" v-on:click="setNone()">
										<i class="fas fa-eye-slash"></i>
									</button>
								</b-tooltip>
							</span>
						</b-field>

						<b-field>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Finding"
								type="is-success"
							>
								<b-tooltip label="Finding" position="is-bottom">
									<b-icon
										:pack="stageStyle('Finding')"
										v-bind:icon="stageStyle('Finding')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Finding</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Evaluating"
								type="is-success"
							>
								<b-tooltip label="Evaluating" position="is-bottom">
									<b-icon
										:pack="stageStyle('Evaluating')"
										v-bind:icon="stageStyle('Evaluating')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Evaluating</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Negotiating"
								type="is-success"
							>
								<b-tooltip label="Negotiating" position="is-bottom">
									<b-icon
										:pack="stageStyle('Negotiating')"
										v-bind:icon="stageStyle('Negotiating')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Negotiating</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Diligence"
								type="is-success"
							>
								<b-tooltip label="Diligence" position="is-bottom">
									<b-icon
										:pack="stageStyle('Diligence')"
										v-bind:icon="stageStyle('Diligence')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Diligence</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Closing"
								type="is-success"
							>
								<b-tooltip label="Closing" position="is-bottom">
									<b-icon
										:pack="stageStyle('Closing')"
										v-bind:icon="stageStyle('Closing')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Closing</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Rehabbing"
								type="is-success"
							>
								<b-tooltip label="Rehabbing" position="is-bottom">
									<b-icon
										:pack="stageStyle('Rehabbing')"
										v-bind:icon="stageStyle('Rehabbing')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Rehabbing</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Leasing"
								type="is-success"
							>
								<b-tooltip label="Leasing" position="is-bottom">
									<b-icon
										:pack="stageStyle('Leasing')"
										v-bind:icon="stageStyle('Leasing')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Leasing</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Selling"
								type="is-success"
							>
								<b-tooltip label="Selling" position="is-bottom">
									<b-icon
										:pack="stageStyle('Selling')"
										v-bind:icon="stageStyle('Selling')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Selling</span>
								</b-tooltip>
							</b-checkbox-button>
							<b-checkbox-button
								v-model="stageGroups"
								native-value="Inactive"
								type="is-success"
							>
								<b-tooltip label="Inactive" position="is-bottom">
									<b-icon
										:pack="stageStyle('Inactive')"
										v-bind:icon="stageStyle('Inactive')"
										size="is-small"
									></b-icon>
									<span v-if="isSuperWide">Inactive</span>
								</b-tooltip>
							</b-checkbox-button>
						</b-field>
					</b-field>
				</b-field>
			</div>
		</div>

		<!-- <p class="content">
            <b>Selection:</b>
            {{ $store.state.propertiesFilter.stages }}
            {{ stageGroups }}
            {{ allStages }}
        </p> -->
	</section>
</template>

<script>
import store from "@/store";
import Helpers from "@/services/Helpers.js";

export default {
  components: {
    Helpers
  },

  data() {
    return {
      stages: Helpers.getStages(),
      defaultStageGroups: [
        "None",
        "Finding",
        "Evaluating",
        "Negotiating",
        "Diligence",
        "Closing",
        "Rehabbing",
        "Leasing",
        "Selling"
      ],
      allStages: [],
      stageGroups: ["None"],
      isResetting: false,
      isSuperWide: Helpers.isSuperWide()
    };
  },

  watch: {
    allStages() {
      if (this.allStages.length > 0)
        this.stageGroups = [
          "None",
          "Finding",
          "Evaluating",
          "Negotiating",
          "Diligence",
          "Closing",
          "Rehabbing",
          "Leasing",
          "Selling",
          "Inactive"
        ];
      else this.stageGroups = ["None"];
    },

    stageGroups() {
      this.$store.state.propertiesFilter.stages = this.stageGroups;
      this.filterProperties();
    }
  },

  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.getWidth);

      //Init
      this.getWidth();
    });

    if (this.$store.getters.session) {
      //   this.$store.state.propertiesFilter.stages = this.defaultStageGroups;
      //   this.stageGroups = this.defaultStageGroups;
      this.stageGroups = this.$store.state.propertiesFilter.stages;
    }
  },

  methods: {
    getWidth() {
      this.isSuperWide = Helpers.isSuperWide();
    },

    filterProperties() {
      if (!this.isResetting) store.dispatch("getProperties");
    },

    resetFilter() {
      this.isResetting = true;
      store.state.propertiesFilter.searchTerm = "";
      this.stageGroups = this.defaultStageGroups;
      store.state.propertiesFilter.startDate = Helpers.addMonths(
        new Date(),
        -1
      );
      store.state.propertiesFilter.endDate = new Date();
      this.isResetting = false;
      this.filterProperties();
    },

    setAll() {
      this.stageGroups = [
        "None",
        "Finding",
        "Evaluating",
        "Negotiating",
        "Diligence",
        "Closing",
        "Rehabbing",
        "Leasing",
        "Selling",
        "Inactive"
      ];
    },

    setNone() {
      this.stageGroups = ["None"];
    },

    stageStyle(stage) {
      return Helpers.getStageStyle(stage);
    }
  }
};
</script>

<style>
</style>
